module.exports = __webpack_public_path__ + "img/third-container-bg.ae6c105c.png";